export default {
  // beforeCreate() {
  //   // 强制设置国际化对象
  //   this._i18n =
  //     this.$root?.$i18n ||
  //     this.$options?.parent?.$i18n ||
  //     document.querySelector("#app").__vue__?.$i18n;
  // },
  methods: {
    // 解决在切换国际化时，element组件不生效问题
    t() {
      const args = Array.prototype.slice.call(arguments);
      args[0] = `platform.${args[0]}`;
      return this.$t.apply(this, args);
    },
  },
};
